import { useState, Fragment } from "react";
import {Combobox, Transition } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/20/solid";

const SearchSelectDropdown = ({ value, onChange, users }) => {
  const [query, setQuery] = useState("");

  const filteredUsers =
    Array.isArray(users) && users.length > 0
      ? query === ""
        ? users
        : users.filter(
            (user) =>
              user?.name?.toLowerCase().includes(query.toLowerCase()) ||
              user?.id?.toString().includes(query)
          )
      : [];

  return (
    <Combobox value={value} onChange={onChange}>
      <div className="relative">
        <Combobox.Input
          className="block w-full text-left cursor-pointer rounded-[12px] bg-[#363D50] border px-[16px] py-[12px] focus:outline-none focus:ring-[#596073] focus:border-[#596073] !text-white placeholder:text-[#A5AEBC] shadow-sm"
          onChange={(event) => setQuery(event.target.value)}
          displayValue={(userId) =>
            users?.find((u) => u?.id === userId)?.name || ""
          }
          placeholder="Name or Id"
        />
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => setQuery("")}
        >
          <Combobox.Options className="absolute mt-1 max-h-40 w-full overflow-auto scrollbar-hide rounded-md bg-[#2C3245] py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-[10000]">
            {filteredUsers?.length === 0 && query !== "" ? (
              <div className="relative cursor-default select-none py-2 px-4 text-gray-300">
                Nothing found.
              </div>
            ) : (
              filteredUsers?.map((user) => (
                <Combobox.Option
                  key={user.id}
                  className={({ active, selected }) =>
                    `relative cursor-pointer py-2 pl-6 pr-4 text-left rounded-[12px] border border-solid border-transparent last:mb-0
                     ${active ? "hover:bg-[#363D50]" : ""} 
                     ${selected ? "bg-[#363D50] !border-[#FFD74A]" : "text-gray-300"}`
                  }
                  value={user.id}
                >
                  {({ selected }) => (
                    <>
                      <span className={`block truncate capitalize ${selected ? "font-medium" : "font-normal"}`}>
                        {user.name}
                      </span>
                      {selected && (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-1 text-yellow-300">
                          <CheckIcon className="h-4 w-4" aria-hidden="true" />
                        </span>
                      )}
                    </>
                  )}
                </Combobox.Option>
              ))
            )}
          </Combobox.Options>
        </Transition>
      </div>
    </Combobox>
  );
};

export default SearchSelectDropdown;
